/* Marcel Afters · WHOLESALE REVEAL (4 Oct 2026). Vanilla, no library, deferred.
   - the live preview: a typed brand name lands on a hangtag, an insole and a box lid; real colourways switch the real photo
   - the kit reveal on scroll (IntersectionObserver) and the hero drift where CSS scroll timelines are missing
   - the phone bottom sheet (drag with the finger, springs on release)
   Preview only: nothing typed is stored, sent or put in a URL. Text is always written with textContent. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.querySelector('[data-mawr]');
  if (!root) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasTimeline = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  root.classList.add('mawr-js');

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function raf(fn) { return window.requestAnimationFrame(fn); }

  /* ---------------- kit reveal ---------------- */
  (function kit() {
    var tiles = $$('.mawr-tile');
    if (!tiles.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { tiles.forEach(function (t) { t.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      var k = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.transitionDelay = (k++ * 80) + 'ms';
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    tiles.forEach(function (t) { io.observe(t); });
  })();

  /* a strip that scrolls sideways must be reachable from the keyboard */
  (function scrollers() {
    var strips = $$('.mawr-objs');
    function mark() { strips.forEach(function (el) { if (el.scrollWidth > el.clientWidth + 1) el.setAttribute('tabindex', '0'); else el.removeAttribute('tabindex'); }); }
    mark();
    window.addEventListener('resize', mark);
  })();

  /* ---------------- hero drift fallback (no CSS scroll timelines) ---------------- */
  (function hero() {
    var h = $('[data-mawr-hero]');
    if (!h || hasTimeline || reduceMotion) return;
    var ticking = false;
    function tick() {
      ticking = false;
      var r = h.getBoundingClientRect();
      var p = clamp(-r.top / Math.max(1, r.height), 0, 1);
      h.style.setProperty('--p', p.toFixed(3));
    }
    function onScroll() { if (!ticking) { ticking = true; raf(tick); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    tick();
  })();

  /* ---------------- the live preview ---------------- */
  var studio = $('[data-mawr-studio]');
  var dataEl = $('[data-mawr-data]');
  if (!studio || !dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var products = (data.products || []).filter(function (p) { return p && p.colours && p.colours.length; });
  if (!products.length) return;
  var sample = data.sample || 'Your brand';

  var input = $('[data-name]', studio);
  var wordmark = $('[data-wordmark]', studio);
  var statusEl = $('[data-status]', studio);
  var imgs = { a: $('[data-img="a"]', studio), b: $('[data-img="b"]', studio) };
  var ptitle = $('[data-ptitle]', studio);
  var cnameEls = $$('[data-cname]', studio);
  var stylesSet = $('[data-styles]', studio);
  var stylesList = $('[data-styles-list]', studio);
  var coloursList = $('[data-colours-list]', studio);
  var coloursNote = $('[data-colours-note]', studio);
  var fitEls = $$('[data-fit]', studio);
  var subTitle = $('[data-sub="title"]', studio);
  var subColour = $('[data-sub="colour"]', studio);
  var objs = $$('.mawr-obj', studio);
  var soleObj = $('.mawr-obj--sole', studio);
  var soleCap = soleObj ? $('figcaption', soleObj) : null;
  var uid = (root.id || 'mawr').replace(/[^a-z0-9_-]/gi, '');

  var state = { pi: 0, ci: 0, name: '' };
  var swapToken = 0;
  var front = 'a';

  /* colour names map to a tint; the name always sits beside it, so colour is never the only cue */
  var TINTS = { black: '#12161f', white: '#f7f7f5', 'oat gray': '#d9d7d1', 'flower gray': '#a9adb4', 'dark gray': '#5c616b', 'light gray': '#cfd2d7', gray: '#9aa0aa', grey: '#9aa0aa',
    coffee: '#7b6a5c', brown: '#6d5a4a', beige: '#d9cdbb', nude: '#e0cbbb', apricot: '#efdcc3', 'navy blue': '#1e2a4a', navy: '#1e2a4a', 'haze blue': '#9fb1c9', 'light blue': '#b9cbe3', 'washed blue': '#8ea3c0', 'gray blue': '#8a9bb3', blue: '#3b5a95', green: '#3d5a4c', 'dark green': '#2f4a3c', khaki: '#bfb497', 'pale khaki': '#d3cbb2', silver: '#c8ccd2', burgundy: '#5b1f2e', wine: '#5b1f2e', cream: '#f1ecdf', almond: '#d8c3a8' };
  function tint(name) {
    var k = String(name || '').toLowerCase();
    if (TINTS[k]) return TINTS[k];
    var keys = ['black', 'white', 'navy', 'blue', 'gray', 'grey', 'brown', 'beige', 'green', 'cream'];
    for (var i = 0; i < keys.length; i++) if (k.indexOf(keys[i]) !== -1) return TINTS[keys[i]];
    return '#c4c9d2';
  }
  function isFootwear(p) { return /shoe|boot|sandal|sneaker|mule|slide|loafer|pump|slipper|footwear/i.test((p.type || '') + ' ' + (p.label || '')); }

  /* ---- fit a typed name into its object: scale the font so it never runs past its box ---- */
  function cleanName(v) {
    return String(v || '').replace(/[\u0000-\u001f\u007f<>]/g, '').replace(/\s+/g, ' ').replace(/^\s+/, '').slice(0, 24);
  }
  function setText(node, text) { if (node.textContent !== text) node.textContent = text; }
  function fit(node) {
    var base = parseFloat(node.getAttribute('data-size')) || 18;
    var max = parseFloat(node.getAttribute('data-max')) || 100;
    node.style.fontSize = base + 'px';
    var w = 0;
    try { w = node.getComputedTextLength(); } catch (e) { w = 0; }
    if (w > max) node.style.fontSize = (base * max / w).toFixed(2) + 'px';
  }
  function fitAll() { fitEls.forEach(fit); if (subTitle) fit(subTitle); if (subColour) fit(subColour); }

  var announceTimer = 0;
  function announce(msg) {
    if (!statusEl) return;
    window.clearTimeout(announceTimer);
    announceTimer = window.setTimeout(function () { statusEl.textContent = msg; }, 700);
  }
  function bump() {
    if (reduceMotion) return;
    objs.forEach(function (o) { o.classList.add('is-bump'); });
    raf(function () { raf(function () { objs.forEach(function (o) { o.classList.remove('is-bump'); }); }); });
  }

  function renderName(announceIt) {
    var shown = state.name || sample;
    var up = shown.toUpperCase();
    setText(wordmark, shown);
    wordmark.classList.toggle('is-sample', !state.name);
    fitEls.forEach(function (n) { setText(n, up); });
    fitAll();
    if (announceIt) announce(state.name ? 'Preview updated. ' + state.name + ' is on the hangtag, the insole and the box lid.' : 'Preview cleared.');
  }

  /* ---- images: preload, decode, then crossfade; stale swaps are dropped, so a quick second tap just retargets ---- */
  var preloaded = {};
  function preload(src) {
    if (!src || preloaded[src]) return;
    var im = new Image();
    im.decoding = 'async';
    im.src = src;
    preloaded[src] = im;
  }
  function preloadProduct(p) { p.colours.forEach(function (c) { preload(c.src); }); }

  function showImage(src, alt, instant) {
    var token = ++swapToken;
    var back = front === 'a' ? 'b' : 'a';
    var b = imgs[back];
    var f = imgs[front];
    if (f.getAttribute('src') === src) { f.alt = alt; return; }
    function commit() {
      if (token !== swapToken) return;
      b.alt = alt;
      b.removeAttribute('aria-hidden');
      f.setAttribute('aria-hidden', 'true');
      f.alt = '';
      b.classList.add('is-front');
      f.classList.remove('is-front');
      front = back;
    }
    b.onload = null;
    b.src = src;
    if (instant) { commit(); return; }
    if (b.decode) { b.decode().then(commit, commit); } else { b.onload = commit; }
  }

  function currentProduct() { return products[state.pi]; }
  function currentColour() { return currentProduct().colours[state.ci] || currentProduct().colours[0]; }

  function renderColour(instant) {
    var p = currentProduct();
    var c = currentColour();
    cnameEls.forEach(function (n) { setText(n, c.n === 'Standard' ? '' : c.n); });
    setText(ptitle, p.title);
    if (subTitle) { setText(subTitle, (p.label || p.type || '').toUpperCase()); }
    if (subColour) { setText(subColour, c.n === 'Standard' ? p.title : c.n); }
    fitAll();
    showImage(c.src, p.title + (c.n === 'Standard' ? '' : ' in ' + c.n), instant);
    var foot = isFootwear(p);
    if (soleObj) soleObj.setAttribute('data-foot', foot ? '1' : '0');
    if (soleCap) soleCap.textContent = foot ? 'Insole print' : 'Insole print (footwear)';
  }

  function renderSwatches() {
    var p = currentProduct();
    coloursList.textContent = '';
    p.colours.forEach(function (c, i) {
      var lab = doc.createElement('label');
      lab.className = 'mawr-swatch';
      var inp = doc.createElement('input');
      inp.type = 'radio';
      inp.name = 'mawr-colour-' + uid;
      inp.value = String(i);
      inp.checked = i === state.ci;
      inp.setAttribute('aria-label', c.n === 'Standard' ? 'Standard colourway' : c.n);
      var sp = doc.createElement('span');
      var dot = doc.createElement('i');
      dot.style.setProperty('--c', tint(c.n));
      sp.appendChild(dot);
      lab.appendChild(inp);
      lab.appendChild(sp);
      coloursList.appendChild(lab);
    });
    var n = p.colours.length;
    coloursNote.textContent = n > 1 ? n + ' real colourways on this style.' : 'One colourway on this style today.';
  }

  function renderStyles() {
    if (products.length < 2) { stylesSet.hidden = true; return; }
    stylesList.textContent = '';
    products.forEach(function (p, i) {
      var lab = doc.createElement('label');
      lab.className = 'mawr-chip';
      var inp = doc.createElement('input');
      inp.type = 'radio';
      inp.name = 'mawr-style-' + uid;
      inp.value = String(i);
      inp.checked = i === state.pi;
      inp.setAttribute('aria-label', p.label + ': ' + p.title);
      var sp = doc.createElement('span');
      sp.textContent = p.label;
      lab.appendChild(inp);
      lab.appendChild(sp);
      stylesList.appendChild(lab);
    });
  }

  function setProduct(i) {
    state.pi = clamp(i, 0, products.length - 1);
    state.ci = 0;
    renderSwatches();
    renderColour(false);
    preloadProduct(currentProduct());
    announce(currentProduct().title + '. ' + currentProduct().colours.length + (currentProduct().colours.length === 1 ? ' colourway.' : ' colourways.'));
    bump();
  }
  function setColour(i) {
    state.ci = clamp(i, 0, currentProduct().colours.length - 1);
    renderColour(false);
    announce('Colourway ' + currentColour().n + '.');
  }

  /* events */
  input.addEventListener('input', function () {
    var v = cleanName(input.value);
    if (v !== input.value && input.value.length > 24) input.value = v;
    state.name = v.replace(/\s+$/, '') === '' ? '' : v;
    renderName(true);
    bump();
  });
  stylesList.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'mawr-style-' + uid) setProduct(parseInt(e.target.value, 10) || 0);
  });
  stylesList.addEventListener('pointerover', function (e) {
    var lab = e.target.closest ? e.target.closest('.mawr-chip') : null;
    if (!lab) return;
    var idx = parseInt($('input', lab).value, 10);
    if (products[idx]) preloadProduct(products[idx]);
  });
  coloursList.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'mawr-colour-' + uid) setColour(parseInt(e.target.value, 10) || 0);
  });

  /* start: the sample label, the hero product, its first colourway (already on the page, so no flash) */
  state.pi = 0; state.ci = 0;
  renderStyles();
  renderSwatches();
  renderColour(true);
  renderName(false);
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fitAll);

  /* preload the colourways when the preview is near the viewport */
  if ('IntersectionObserver' in window) {
    var pio = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { preloadProduct(currentProduct()); pio.disconnect(); }
    }, { rootMargin: '900px 0px' });
    pio.observe(studio);
  } else { preloadProduct(currentProduct()); }

  /* ---------------- the bottom sheet (phones) ---------------- */
  (function sheet() {
    var ctl = $('[data-ctl]', studio);
    var handle = $('[data-handle]', studio);
    var body = $('[data-ctl-body]', studio);
    var label = $('[data-handle-t]', studio);
    if (!ctl || !handle) return;
    var mq = window.matchMedia('(max-width: 899px)');
    var open = true;
    var peek = 0;
    var dragging = false, startY = 0, startOffset = 0, lastY = 0, lastT = 0, vel = 0, offset = 0;

    function measure() {
      /* what stays visible when closed: the grab handle and the name field */
      var hh = handle.offsetHeight;
      var fld = $('.mawr-field', ctl);
      var safe = Math.max(0, (parseFloat(getComputedStyle(ctl).paddingBottom) || 0) - 14);
      peek = hh + (fld ? fld.offsetHeight : 0) + safe + 10;
    }
    function closedOffset() { return Math.max(0, ctl.offsetHeight - peek); }
    function apply(o, animate) {
      offset = o;
      if (!animate) ctl.classList.add('is-drag'); else ctl.classList.remove('is-drag');
      ctl.style.setProperty('--sheet-y', Math.round(o) + 'px');
    }
    function setOpen(v, silent) {
      open = v;
      measure();
      apply(v ? 0 : closedOffset(), true);
      handle.setAttribute('aria-expanded', v ? 'true' : 'false');
      if (label) label.textContent = v ? 'Hide controls' : 'Show controls';
      $$('.mawr-set', ctl).forEach(function (el) { el.inert = !v && mq.matches; });
      if (!silent) announce(v ? 'Controls shown.' : 'Controls hidden. The name field stays.');
    }
    function reset() {
      if (!mq.matches) { ctl.style.removeProperty('--sheet-y'); ctl.classList.remove('is-drag'); handle.setAttribute('aria-expanded', 'true'); $$('.mawr-set', ctl).forEach(function (el) { el.inert = false; }); return; }
      setOpen(open, true);
    }
    handle.addEventListener('click', function () { if (dragging) return; setOpen(!open); });
    handle.addEventListener('pointerdown', function (e) {
      if (!mq.matches) return;
      measure();
      dragging = false;
      startY = lastY = e.clientY; lastT = e.timeStamp; vel = 0; startOffset = offset;
      try { handle.setPointerCapture(e.pointerId); } catch (x) { /* older engines */ }
      handle.__down = true;
    });
    handle.addEventListener('pointermove', function (e) {
      if (!handle.__down) return;
      var dy = e.clientY - startY;
      if (!dragging && Math.abs(dy) > 4) { dragging = true; }
      if (!dragging) return;
      var dt = Math.max(1, e.timeStamp - lastT);
      vel = (e.clientY - lastY) / dt;
      lastY = e.clientY; lastT = e.timeStamp;
      var max = closedOffset();
      var o = startOffset + dy;
      /* rubber band past either end */
      if (o < 0) o = o / 3; else if (o > max) o = max + (o - max) / 3;
      apply(o, false);
    });
    function end(e) {
      if (!handle.__down) return;
      handle.__down = false;
      try { handle.releasePointerCapture(e.pointerId); } catch (x) { /* ignore */ }
      if (!dragging) return;
      var max = closedOffset();
      var projected = offset + vel * 220;
      setOpen(projected < max / 2, true);
      /* keep the click that follows a drag from toggling again */
      window.setTimeout(function () { dragging = false; }, 0);
    }
    handle.addEventListener('pointerup', end);
    handle.addEventListener('pointercancel', end);
    handle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setOpen(false); }
      if (e.key === 'ArrowUp') { e.preventDefault(); setOpen(true); }
    });
    if (mq.addEventListener) mq.addEventListener('change', reset); else if (mq.addListener) mq.addListener(reset);
    window.addEventListener('resize', function () { if (mq.matches) { measure(); if (!open) apply(closedOffset(), true); } });
    void body;
    reset();
  })();

  /* analytics: counts only, never the typed name */
  $$('[data-mawr-cta]').forEach(function (a) {
    a.addEventListener('click', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'reveal_cta', placement: a.getAttribute('data-mawr-cta') });
    });
  });
})();
